export default {"src":"/_next/static/media/deliver.0470edd2.svg","height":520,"width":800,"blurWidth":0,"blurHeight":0};